export var MIN_SMALL_CELL_WIDTH = 240;
export var MIN_MEDIUM_CELL_WIDTH = 420;
export var MAX_SMALL_CELL_WIDTH = 320;
export var MAX_MEDIUM_CELL_WIDTH = 620;
